import storageKeys from '../consts/storageKeys';
import {selectUserId} from '../state/selectors/auth';
import {getState} from '../state/store';

const setWasInstallationGuideShown = () => {
    localStorage.setItem(storageKeys.WAS_INSTALLATION_GUIDE_SHOWN, 'true');
};
const getWasInstallationGuideShown = () => localStorage.getItem(storageKeys.WAS_INSTALLATION_GUIDE_SHOWN);

const getAgeGateFromStorage = () => localStorage.getItem(storageKeys.AGE_GATE);
const setAgeGateToStorage = () => localStorage.setItem(storageKeys.AGE_GATE, true);

const getIsGetStartedPageShown = () => localStorage.getItem(storageKeys.IS_GET_STARTED_PAGE_SHOWN);
const setIsGetStartedPageShown = () => localStorage.setItem(storageKeys.IS_GET_STARTED_PAGE_SHOWN, true);

const getCountryCodeFromLocalStorage = () => localStorage.getItem(storageKeys.COUNTRY_CODE);
const setCountryCodeToLocalStorage = (code) => localStorage.setItem(storageKeys.COUNTRY_CODE, code);

const getApiCountryCodeFromLocalStorage = () => localStorage.getItem(storageKeys.API_COUNTRY_CODE);
const setApiCountryCodeToLocalStorage = (code) => localStorage.setItem(storageKeys.API_COUNTRY_CODE, code);

const getGeoRestrictionFromLocalStorage = () => localStorage.getItem(storageKeys.GEO_RESTRICTION);
const setGeoRestrictionToLocalStorage = (value) => localStorage.setItem(storageKeys.GEO_RESTRICTION, value);
const removeGeoRestrictionFromLocalStorage = () => localStorage.removeItem(storageKeys.GEO_RESTRICTION);

const setLanguageCodeToLocalStorage = (code) => localStorage.setItem(storageKeys.LANGUAGE_CODE, code);
const removeLanguageCodeFromLocalStorage = () => localStorage.removeItem(storageKeys.LANGUAGE_CODE);
const getLanguageCodeFromLocalStorage = () => localStorage.getItem(storageKeys.LANGUAGE_CODE);

const setThemeToLocalStorage = (theme) => localStorage.setItem(storageKeys.THEME, theme);
const getThemeFromLocalStorage = () => localStorage.getItem(storageKeys.THEME);
const removeThemeFromLocalStorage = () => localStorage.removeItem(storageKeys.THEME);

const setLogStreamNameToLocalStorage = (uuid) => localStorage.setItem(storageKeys.APP_LOG_STREAM_UUID, uuid);
const getLogStreamNameFromLocalStorage = () => localStorage.getItem(storageKeys.APP_LOG_STREAM_UUID);

const setIsInitialSetupCompleted = () => localStorage.setItem(storageKeys.IS_INITIAL_SETUP_COMPLETED, true);
const getIsInitialSetupCompleted = () => localStorage.getItem(storageKeys.IS_INITIAL_SETUP_COMPLETED);

const setSubscriptionLanguageCodeToStorage = (code) =>
    localStorage.setItem(storageKeys.SUBSCRIPTION_LANGUAGE_CODE, code);
const getSubscriptionLanguageCodeFromStorage = () => localStorage.getItem(storageKeys.SUBSCRIPTION_LANGUAGE_CODE);
const removeSubscriptionLanguageCodeFromStorage = () => localStorage.removeItem(storageKeys.SUBSCRIPTION_LANGUAGE_CODE);

const setSubscriptionNotificationTypesToStorage = (types) =>
    localStorage.setItem(storageKeys.SUBSCRIPTION_NOTIFICATION_TYPES, JSON.stringify(types));
const getSubscriptionNotificationTypesFromStorage = () =>
    JSON.parse(localStorage.getItem(storageKeys.SUBSCRIPTION_NOTIFICATION_TYPES));
const removeSubscriptionNotificationTypesFromStorage = () =>
    localStorage.removeItem(storageKeys.SUBSCRIPTION_NOTIFICATION_TYPES);

const setSubscriptionPermissionToStorage = (permission) =>
    localStorage.setItem(storageKeys.SUBSCRIPTION_PERMISSION, permission);
const getSubscriptionPermissionFromStorage = () => localStorage.getItem(storageKeys.SUBSCRIPTION_PERMISSION);

const setSubscriptionPublicKeyToStorage = (publicKey) =>
    localStorage.setItem(storageKeys.SUBSCRIPTION_PUBLIC_KEY, publicKey);
const getSubscriptionPublicKeyFromStorage = () => localStorage.getItem(storageKeys.SUBSCRIPTION_PUBLIC_KEY);
const removeSubscriptionPublicKeyFromStorage = () => localStorage.removeItem(storageKeys.SUBSCRIPTION_PUBLIC_KEY);

const setIsSubscriptionUnsubscribed = () => localStorage.setItem(storageKeys.IS_SUBSCRIPTION_UNSUBSCRIBED, true);
const getIsSubscriptionUnsubscribed = () => localStorage.getItem(storageKeys.IS_SUBSCRIPTION_UNSUBSCRIBED) === 'true';
const removeIsSubscriptionUnsubscribed = () => localStorage.removeItem(storageKeys.IS_SUBSCRIPTION_UNSUBSCRIBED);

const setIsExperienceConcentAccepted = () => localStorage.setItem(storageKeys.IS_EXPERIENCE_CONSENTS_ACCEPTED, true);
const getIsExperienceConcentAccepted = () =>
    localStorage.getItem(storageKeys.IS_EXPERIENCE_CONSENTS_ACCEPTED) === 'true';
const removeIsExperienceConcentAccepted = () => localStorage.removeItem(storageKeys.IS_EXPERIENCE_CONSENTS_ACCEPTED);

const setIsUsageConcentAccepted = () => localStorage.setItem(storageKeys.IS_USAGE_CONSENTS_ACCEPTED, true);
const getIsUsageConcentAccepted = () => localStorage.getItem(storageKeys.IS_USAGE_CONSENTS_ACCEPTED) === 'true';
const removeIsUsageConcentAccepted = () => localStorage.removeItem(storageKeys.IS_USAGE_CONSENTS_ACCEPTED);

const setIsADConcentAccepted = () => localStorage.setItem(storageKeys.IS_AD_CONSENTS_ACCEPTED, true);
const getIsADConcentAccepted = () => localStorage.getItem(storageKeys.IS_AD_CONSENTS_ACCEPTED);

const getDisabledNotificationTypes = () =>
    JSON.parse(localStorage.getItem(storageKeys.DISABLED_NOTIFICATION_TYPES)) || {};
const setDisabledNotificationTypes = (subTypes) =>
    localStorage.setItem(storageKeys.DISABLED_NOTIFICATION_TYPES, JSON.stringify(subTypes));

const getIsCredentialsPopupHidden = () => localStorage.getItem(storageKeys.CREDENTIALS_POPUP_HIDDEN) === 'true';
const setIsCredentialsPopupHidden = (isHidden) => localStorage.setItem(storageKeys.CREDENTIALS_POPUP_HIDDEN, isHidden);

const getIsBrowserCheckDisabled = () => localStorage.getItem(storageKeys.BROWSER_CHECK) === 'false';
const setIsBrowserCheckDisabled = () => localStorage.setItem(storageKeys.BROWSER_CHECK, false);
const removeIsBrowserCheckDisabled = () => localStorage.removeItem(storageKeys.BROWSER_CHECK);

const getUserData = (storageKey) => {
    const userId = selectUserId(getState());

    if (!userId) return;

    const data = JSON.parse(localStorage.getItem(storageKey) || '{}');

    return data[userId];
};

const setUserData = (storageKey, userData) => {
    const userId = selectUserId(getState());

    if (!userId) return;

    const data = JSON.parse(localStorage.getItem(storageKey) || '{}');

    data[userId] = userData;
    localStorage.setItem(storageKey, JSON.stringify(data));
};

const setIsConversionStartTipHidden = () => setUserData(storageKeys.IS_CONVERSION_START_TIP_HIDDEN, true);
const getIsConversionStartTipHidden = () => getUserData(storageKeys.IS_CONVERSION_START_TIP_HIDDEN) === true;

const setIsConversionRestartTipHidden = () => setUserData(storageKeys.IS_CONVERSION_RESTART_TIP_HIDDEN, true);
const getIsConversionRestartTipHidden = () => getUserData(storageKeys.IS_CONVERSION_RESTART_TIP_HIDDEN) === true;

const getShownFeedbackFeatures = () => getUserData(storageKeys.SHOWN_FEEDBACK_FEATURES) || {};
const setShownFeedbackFeature = (feature) =>
    setUserData(storageKeys.SHOWN_FEEDBACK_FEATURES, {...getShownFeedbackFeatures(), [feature]: true});

const getIsVisibilityReconnectDisabled = () =>
    localStorage.getItem(storageKeys.IS_VISIBILITY_RECONNECT_DISABLED) === 'true';
const setIsVisibilityReconnectDisabled = (value) =>
    localStorage.setItem(storageKeys.IS_VISIBILITY_RECONNECT_DISABLED, value);

const getCompletionMessageQueue = () => {
    const queue = localStorage.getItem(storageKeys.COMPLETION_MESSAGE_QUEUE);

    return queue ? JSON.parse(queue) : [];
};
const setCompletionMessageQueue = (queue) => {
    localStorage.setItem(storageKeys.COMPLETION_MESSAGE_QUEUE, JSON.stringify(queue));
};

const addItemToCompletionMessageQueue = (item) => {
    const queue = getCompletionMessageQueue();

    queue.push(item);

    setCompletionMessageQueue(queue);
};
const deleteItemFromCompletionMessageQueue = (item) => {
    const queue = getCompletionMessageQueue();
    const itemIndex = queue.indexOf(item);

    if (itemIndex > -1) {
        queue.splice(itemIndex, 1);

        setCompletionMessageQueue(queue);
    }
};

// ── Device kit map ──────────────────────────
// Structure: { [chargerDusn]: holderDusn }
// Used as a fallback when the API doesn't return kit info (i5 disconnected state)

const getDeviceKitMap = () => getUserData(storageKeys.DEVICE_KIT_MAP) || {};

const setDeviceKitMapEntry = (chargerDusn, holderDusn) => {
    const kitMap = getDeviceKitMap();

    kitMap[chargerDusn] = holderDusn;
    setUserData(storageKeys.DEVICE_KIT_MAP, kitMap);
};

// Removes dusn from the kit map regardless of whether it's a holder or a charger
const removeDeviceKitMapEntry = (dusn) => {
    const kitMap = getDeviceKitMap();

    // dusn is a charger (key)
    const isCharger = Boolean(kitMap[dusn]);
    // dusn is a holder (value) — find which charger points to it
    const pairedCharger = Object.keys(kitMap).find((charger) => kitMap[charger] === dusn);

    // If dusn not found in kit map — nothing to clean up
    if (!isCharger && !pairedCharger) return;

    // Remove the charger entry
    delete kitMap[dusn];

    // If this dusn is a holder, also remove the charger that pointed to it
    if (pairedCharger) delete kitMap[pairedCharger];

    setUserData(storageKeys.DEVICE_KIT_MAP, kitMap);
};

// ── Device sync date map ────────────────────
// Structure: { [dusn]: synchronizeUpdateDate }
// Used as a fallback when the API doesn't return sync date (i5) or state was reset (app restart)

const getDeviceSyncDateMap = () => getUserData(storageKeys.DEVICE_SYNC_DATE_MAP) || {};

const getDeviceSyncDate = (dusn) => getDeviceSyncDateMap()[dusn];

const setDeviceSyncDateEntry = (dusn, synchronizeUpdateDate) => {
    const syncDateMap = getDeviceSyncDateMap();

    syncDateMap[dusn] = synchronizeUpdateDate;
    setUserData(storageKeys.DEVICE_SYNC_DATE_MAP, syncDateMap);
};

const removeDeviceSyncDateEntry = (dusn) => {
    const syncDateMap = getDeviceSyncDateMap();

    delete syncDateMap[dusn];
    setUserData(storageKeys.DEVICE_SYNC_DATE_MAP, syncDateMap);
};

const getAnalyticsSessionId = () => localStorage.getItem(storageKeys.ANALYTICS_SESSION_ID);
const setAnalyticsSessionId = (id) => localStorage.setItem(storageKeys.ANALYTICS_SESSION_ID, id);

const parseStoredJson = (key, fallback) => {
    try {
        return JSON.parse(localStorage.getItem(key)) ?? fallback;
    } catch {
        return fallback;
    }
};

const getEcFlow = () => parseStoredJson(storageKeys.EC_FLOW, null);
const setEcFlow = (flow) => localStorage.setItem(storageKeys.EC_FLOW, JSON.stringify(flow));
const removeEcFlow = () => localStorage.removeItem(storageKeys.EC_FLOW);

const getEcPushes = () => parseStoredJson(storageKeys.EC_PUSHES, {});
const setEcPushes = (pushes) => localStorage.setItem(storageKeys.EC_PUSHES, JSON.stringify(pushes));

const getVoxlinkSession = () => parseStoredJson(storageKeys.VOXLINK_SESSION, null);
const setVoxlinkSession = (session) => localStorage.setItem(storageKeys.VOXLINK_SESSION, JSON.stringify(session));
const removeVoxlinkSession = () => localStorage.removeItem(storageKeys.VOXLINK_SESSION);

const storageService = {
    setWasInstallationGuideShown,
    getWasInstallationGuideShown,
    getAgeGateFromStorage,
    setAgeGateToStorage,
    setLanguageCodeToLocalStorage,
    removeLanguageCodeFromLocalStorage,
    getLanguageCodeFromLocalStorage,
    getIsGetStartedPageShown,
    setIsGetStartedPageShown,
    setThemeToLocalStorage,
    getThemeFromLocalStorage,
    removeThemeFromLocalStorage,
    setLogStreamNameToLocalStorage,
    getLogStreamNameFromLocalStorage,
    setIsInitialSetupCompleted,
    getIsInitialSetupCompleted,
    setSubscriptionLanguageCodeToStorage,
    getSubscriptionLanguageCodeFromStorage,
    removeSubscriptionLanguageCodeFromStorage,
    setSubscriptionNotificationTypesToStorage,
    getSubscriptionNotificationTypesFromStorage,
    removeSubscriptionNotificationTypesFromStorage,
    getCountryCodeFromLocalStorage,
    setCountryCodeToLocalStorage,
    getApiCountryCodeFromLocalStorage,
    setApiCountryCodeToLocalStorage,
    setSubscriptionPermissionToStorage,
    getSubscriptionPermissionFromStorage,
    setSubscriptionPublicKeyToStorage,
    getSubscriptionPublicKeyFromStorage,
    removeSubscriptionPublicKeyFromStorage,
    setIsSubscriptionUnsubscribed,
    getIsSubscriptionUnsubscribed,
    removeIsSubscriptionUnsubscribed,
    setIsExperienceConcentAccepted,
    getIsExperienceConcentAccepted,
    removeIsExperienceConcentAccepted,
    setIsUsageConcentAccepted,
    getIsUsageConcentAccepted,
    removeIsUsageConcentAccepted,
    setIsADConcentAccepted,
    getIsADConcentAccepted,
    getDisabledNotificationTypes,
    setDisabledNotificationTypes,
    getIsCredentialsPopupHidden,
    setIsCredentialsPopupHidden,
    getIsBrowserCheckDisabled,
    setIsBrowserCheckDisabled,
    removeIsBrowserCheckDisabled,
    getGeoRestrictionFromLocalStorage,
    setGeoRestrictionToLocalStorage,
    removeGeoRestrictionFromLocalStorage,
    setIsConversionStartTipHidden,
    getIsConversionStartTipHidden,
    setIsConversionRestartTipHidden,
    getIsConversionRestartTipHidden,
    getCompletionMessageQueue,
    setCompletionMessageQueue,
    addItemToCompletionMessageQueue,
    deleteItemFromCompletionMessageQueue,
    getShownFeedbackFeatures,
    setShownFeedbackFeature,
    getIsVisibilityReconnectDisabled,
    setIsVisibilityReconnectDisabled,
    getDeviceKitMap,
    setDeviceKitMapEntry,
    removeDeviceKitMapEntry,
    getDeviceSyncDate,
    setDeviceSyncDateEntry,
    removeDeviceSyncDateEntry,
    getAnalyticsSessionId,
    setAnalyticsSessionId,
    getEcFlow,
    setEcFlow,
    removeEcFlow,
    getEcPushes,
    setEcPushes,
    getVoxlinkSession,
    setVoxlinkSession,
    removeVoxlinkSession,
};

export default storageService;
